import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="bg-gray-900 text-white">
      <div className="mx-auto max-w-7xl px-6 py-12 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold text-gold-400 mb-4">Kamal Institute</h3>
            <p className="text-gray-300 mb-4">
              {t('footer.tagline')}
            </p>
            <div className="mt-6 flex flex-col gap-4">
              <div>
                <p className="text-sm text-gray-400 mb-1.5">{t('footer.catalogueLabel')}</p>
                <a
                  href="https://www.instagram.com/kjbr_ajm"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center rounded-md bg-gold-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-gold-500 transition-colors"
                >
                  {t('footer.kamalJewellers')}
                </a>
              </div>
              <div>
                <p className="text-sm text-gray-400 mb-1.5">{t('footer.bullionLabel')}</p>
                <a
                  href="https://kamalbullion.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center rounded-md bg-white/10 px-5 py-2.5 text-sm font-semibold text-white ring-1 ring-white/30 hover:bg-white/20 transition-colors"
                >
                  {t('footer.kamalBullion')}
                </a>
              </div>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-gold-400 transition-colors">
                  {t('footer.home')}
                </Link>
              </li>
              <li>
                <Link to="/courses" className="text-gray-300 hover:text-gold-400 transition-colors">
                  {t('footer.courses')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-gold-400 transition-colors">
                  {t('footer.aboutUs')}
                </Link>
              </li>
              <li>
                <Link to="/activities" className="text-gray-300 hover:text-gold-400 transition-colors">
                  {t('footer.activities')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-gold-400 transition-colors">
                  {t('footer.contact')}
                </Link>
              </li>
              <li>
                <Link to="/admin" className="text-gray-300 hover:text-gold-400 transition-colors">
                  {t('footer.admin')}
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('footer.contactInfo')}</h4>
            <ul className="space-y-2 text-gray-300">
              <li>{t('footer.addressCity')}</li>
              <li>{t('footer.addressCountry')}</li>
              <li className="mt-4">
                <a href="mailto:info@kamalbullion.com" className="hover:text-gold-400 transition-colors">
                  info@kamalbullion.com
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-8 border-t border-gray-700 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} Kamal Institute. {t('footer.allRightsReserved')}</p>
          <p className="mt-2 text-sm">{t('footer.byBindalInfotech')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
